<template>
  <!-- Register Modal -->
  <div
    id="regModal"
    class="modal fade black-modal"
    role="dialog"
    data-backdrop="true"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-header-inner">
            สร้างบัญชีของคุณ
            <p>กรอกข้อมูลจริงเท่านั้น เพื่อผลประโยชน์ของคุณเองในการถอนเงิน</p>
          </div>
          <div class="modal-close" data-dismiss="modal">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>
        <div class="modal-body">
          <!-- <div class="info-2 regInfo">โปรดกรอกข้อมูลเพื่อลงทะเบียน</div> -->
          <div class="modal-cont fullReg" id="full_register_field">
            <form >
             
           <div class="form-group form-special" id="form2" v-if="ReqStep == 1">
            <div class="input-holder mb-3">
              <input
                type="tel"
                id="phone"
                maxlength="10"
                name="phone"
                placeholder="เบอร์มือถือ"
                class="regData form-control"
                v-model="PhoneNumber"
              />
            </div>
             
            <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>
            <div
                  id=""
                  class="button button-big button-submit button-login-modal text-uppercase"
                  @click="Register()"
                >
                  ต่อไป
             </div>
             
          </div>
          <div class="form-group form-special" id="form2" v-if="ReqStep == 2">
              <div class="input-holder mb-3">
              <select  name="banks" id="banks" class="regData form-control" v-model="BankCode"
                ><option selected="selected" value="-1">เลือกธนาคาร</option>
                <option
                  v-for="(item, i) in nameBankArrayList"
                  :key="i"
                  :value="item.id"
                  >{{ item.value }}</option
                >
              </select>
              </div>
              <div class="jErr"></div>
              <div class="input-holder mb-3">
              <input
                type="tel"
                id="bank_number"
                maxlength="15"
                name="bank_number"
                placeholder="เลขที่บัญชี"
                class="regData form-control "
                v-model="BankNumber"
              />
             </div>


              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>

              

              <div
                  id=""
                  class="button button-big button-submit button-login-modal text-uppercase"
                  @click="Register()"
                >
                  ต่อไป
             </div>

            </div>
            <div class="form-group form-special" id="form2" v-if="ReqStep == 3">
              <div class="input-holder mb-3">
                <input
                  type="tel"
                  id="phone"
                  maxlength="10"
                  name="phone"
                  placeholder="เบอร์มือถือ"
                  class="regData form-control "
                  v-model="PhoneNumber"
                  readonly
                />
              </div>
              <div class="input-holder mb-3">
                  <input
                    :type="showPassRegister == false ? 'password' : 'text'"
                    id="password"
                    maxlength="15"
                    name="password"
                    placeholder="รหัสผ่าน"
                    class="regData form-control "
                    v-model="Password"
                  />
                  <span class="input-icon i-password">
                    <i @click="showPassRegister = !showPassRegister" class="far fa-eye" v-if="showPassRegister == false"></i>
                    <i @click="showPassRegister = !showPassRegister" class="far fa-eye-slash" v-if="showPassRegister == true"></i>
                    </span>
              
                
              </div>
              <div class="input-holder mb-3">
              <select name="banks" id="banks" readonly class="regData form-control " v-model="BankCode"
                ><option selected="selected" value="-1" disabled="true"
                  >เลือกธนาคาร</option
                >
                <option disabled="true"
                  v-for="(item, i) in nameBankArrayList"
                  :key="i"
                  :value="item.id"
                  >{{ item.value }}</option
                >
              </select>
            </div>
            <div class="input-holder mb-3">
              <input
                type="text"
                class="regData form-control "
                id="bankacc_mb"
                placeholder="เลขบัญชี"
                autocomplete="none"
                readonly
                v-model="BankNumber"
              />
            </div>
            <div class="input-holder mb-3">

              <input
                type="text"
                id="full_name"
                maxlength="100"
                name="full_name"
                placeholder="ชื่อ"
                class="regData form-control "
                :disabled="tokenBank != ''"
                v-model="FirstName"
              />
            </div>
            <div class="input-holder mb-3">
              <input
                type="text"
                id="full_name"
                maxlength="100"
                name="full_name"
                placeholder="นามสกุล"
                class="regData form-control "
                :disabled="tokenBank != ''"
                v-model="LastName"
              />
            </div>
            <div class="input-holder mb-3">
              <input
                type="text"
                id="WalletId"
                maxlength="100"
                name="WalletId"
                placeholder="ทรูวอเล็ทไอดี"
                class="regData form-control "
                v-model="WalletId"
              />
            </div>
            <div >
              สำหรับลูกค้าที่ฝากเงินด้วยวอเล็ท และ ตั้งค่าวอเล็ทไอดีหน้าแอพทรูวอเล็ท กรุณากรอก วอเล็ทไอดีให้ตรง เพื่อฝากเงินอัตโนมัติ
            </div>
            <div class="jErr"></div>

            <div class="input-holder mb-3">
              <input
                type="text"
                class="regData form-control"
                id="name_mb"
                placeholder="รหัสแนะนำ"
                autocomplete="none"
                readonly
                v-model="shareToken"
              />
            </div>
            <div class="input-holder mb-3">
              <select name="banks" id="banks" rea class="" v-model="isBonus"
                ><option :value="true">รับโปรโมชั่น</option>
                <option selected="selected" :value="false"
                  >ไม่รับโปรโมชั่น</option
                >
              </select>
            </div>
            
              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>

              <div
                  id=""
                  class="button button-big button-submit button-login-modal text-uppercase"
                  @click="Register()"
                >
                สมัครสมาชิก
             </div>
            </div>
            <div class="modalspanbox">
              เป็นสมาชิกอยู่แล้ว?
              <a href="javascript:void(0)" @click="Login()" class="loginbtn"
                >เข้าสู่ระบบ</a
              >
            </div>


              <div class="resp"></div>
               
            </form>
          </div>

       

          <div class="social-cont hide">
            <hr />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--   
  <div id="authModal">
    <div class="registermodaldiv" id="register" data-backdrop="false">
      <div class="modaldiv">
        <div class="contentmodal animate__animated animate__bounceInDown">
          <button class="closepopup" data-dismiss="modal">
            <i class="fas fa-times"></i>
          </button>
          <form class="login">
            <div class="logopopup">
              <img src="/static/img/logo/main_logo_20221004223046.png" />
            </div>
            <h1>สมัครสมาชิก</h1>
            <div id="form2" v-if="ReqStep == 1">
              <input id="aff" type="text" maxlength="10" value="" hidden="" />
              <input
                id="affiliate"
                type="text"
                maxlength="10"
                value=""
                hidden=""
              />
              <input
                type="tel"
                id="phone"
                maxlength="10"
                name="phone"
                placeholder="เบอร์มือถือ"
                class="mb-3"
                v-model="PhoneNumber"
              />
              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>
              <a
                href="javascript:{}"
                @click="Register()"
                id="btnLogin"
                class="btnLogin"
                >ถัดไป</a
              >
            </div>
            <div id="form2" v-if="ReqStep == 2">
              <select name="banks" id="banks" class="mb-3" v-model="BankCode"
                ><option selected="selected" value="-1">เลือกธนาคาร</option>
                <option
                  v-for="(item, i) in nameBankArrayList"
                  :key="i"
                  :value="item.id"
                  >{{ item.value }}</option
                >
              </select>
              <input
                type="tel"
                id="bank_number"
                maxlength="15"
                name="bank_number"
                placeholder="เลขที่บัญชี"
                class="mb-3"
                v-model="BankNumber"
              />

              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>
              <a
                href="javascript:{}"
                @click="Register()"
                id="btnLogin"
                class="btnLogin"
                >ถัดไป</a
              >
            </div>
            <div id="form2" v-if="ReqStep == 3">
              <input
                type="tel"
                id="phone"
                maxlength="10"
                name="phone"
                placeholder="เบอร์มือถือ"
                class="mb-3"
                v-model="PhoneNumber"
                readonly
              />
              <div class="inputRightbtn">
                <div class="divInput">
                  <input
                    :type="showPassRegister == false ? 'password' : 'text'"
                    id="password"
                    maxlength="15"
                    name="password"
                    placeholder="รหัสผ่าน"
                    class="mb-3"
                    v-model="Password"
                  />
                </div>
                <div>
                  <a
                    href="#"
                    id="btnVerifyAccount"
                    @click="showPassRegister = !showPassRegister"
                    class="btnLogin btnOtp btnVerifyAccount"
                    ><i class="far fa-eye" v-if="showPassRegister == false"></i>
                    <i
                      class="far fa-eye-slash"
                      v-if="showPassRegister == true"
                    ></i>
                  </a>
                </div>
              </div>
              <select name="banks" id="banks" class="mb-3" v-model="BankCode"
                ><option selected="selected" value="-1" disabled="true"
                  >เลือกธนาคาร</option
                >
                <option
                  v-for="(item, i) in nameBankArrayList"
                  :key="i"
                  :value="item.id"
                  >{{ item.value }}</option
                >
              </select>
              <input
                type="text"
                class="mb-3"
                id="bankacc_mb"
                placeholder="เลขบัญชี"
                autocomplete="none"
                readonly
                v-model="BankNumber"
              />
              <input
                type="text"
                id="full_name"
                maxlength="100"
                name="full_name"
                placeholder="ชื่อ"
                class="mb-3"
                v-model="FirstName"
              />
              <input
                type="text"
                id="full_name"
                maxlength="100"
                name="full_name"
                placeholder="นามสกุล"
                class="mb-3"
                v-model="LastName"
              />
              <input
                type="text"
                id="WalletId"
                maxlength="100"
                name="WalletId"
                placeholder="ทรูวอเล็ทไอดี"
                class="mb-3"
                v-model="WalletId"
              />
              สำหรับลูกค้าที่ฝากเงินด้วยวอเล็ท และ ตั้งค่าวอเล็ทไอดีหน้าแอพทรูวอเล็ท กรุณากรอก วอเล็ทไอดีให้ตรง เพื่อฝากเงินอัตโนมัติ
              <input
                type="tel"
                class="mb-3"
                id="name_mb"
                placeholder="รหัสแนะนำ"
                autocomplete="none"
                v-model="shareToken"
              />
              <select name="banks" id="banks" class="mb-3" v-model="isBonus"
                ><option :value="true">รับโปรโมชั่น</option>
                <option selected="selected" :value="false"
                  >ไม่รับโปรโมชั่น</option
                >
              </select>
              <div class="mb-3">
                <div class="text-center">
                  <small class="text-warning"
                    >*ข้อมูลบัญชีที่ถูกบัญทึกไปแล้วจะไม่สามารถแก้ไขเองได้</small
                  >
                </div>
                <div class="text-center">
                  <small class="text-warning"
                    >กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</small
                  >
                </div>
              </div>
              <a
                href="javascript:{}"
                @click="Register()"
                id="btnLogin"
                class="btnLogin"
                >สมัครสมาชิก</a
              >
            </div>
            <div class="modalspanbox">
              เป็นสมาชิกอยู่แล้ว?
              <a href="javascript:void(0)" @click="Login()" class="loginbtn"
                >เข้าสู่ระบบ</a
              >
            </div>
          </form>
        </div>
        <div class="overlaymodal"></div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { nameBankArray } from "@/services/modules/Bank.services.js";
import { nameBankArrayList } from "@/config/Bank.js";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { checkPhoneNumber, checkBankNumber } from "@/services/modules/user.js";

export default {
  name: "RegisterForm",
  data() {
    return {
      // register
      PhoneNumber: "",
      Password: "",
      ConfirmPassword: "",
      BankCode: "-1",
      WalletId: "",
      BankNumber: "",
      FirstName: "",
      LastName: "",
      SignupToken: "",
      step: 1,
      login: false,
      shareToken: this.$route.query.shareToken,
      isBonus: false,
      tokenBank: "",
      Confirm_Password: "",
      showPassRegisterConfirm: "",
      showPassRegister: false,
      nameBankArrayList: nameBankArrayList,
      ReqStep: 1,
      Partner: "",
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
    ]),
  },
  methods: {
    ...mapMutations(["setLoading", "setLineId"]),
    ...mapActions(["userSignIn", "setError", "userSignUp"]),
    async Register() {
      this.setError(null);
      if (this.ReqStep == 1) {
        return this.Step1checkPhoneNumber();
      } else if (this.ReqStep == 2) {
        return this.Step2checkBankNumber();
      } else {
        let registerDATA = {
          phoneNumber: this.PhoneNumber,
          Password: this.Password,
          Confirm_Password: this.Password,
          BankAccount: this.BankNumber,
          BankCode: this.BankCode,
          firstName: this.FirstName,
          lastName: this.LastName,
          tokenBank: this.tokenBank,
          affiliateKey: this.shareToken,
          isBonus: this.isBonus,
          WalletId: this.WalletId,
        };
        await this.userSignUp(registerDATA);
        if (this.getError) {
          return this.$swal.fire(this.getError, "", "error");
        } else {
          return this.$swal.fire("ลงทะเบียนเรียบร้อยแล้ว", "", "success");
        }
      }
    },

    async Step1checkPhoneNumber() {
      if (this.PhoneNumber.length != 10)
        return this.$swal.fire(
          "หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่",
          "",
          "error"
        );
      if (this.PhoneNumber == "" || this.PhoneNumber.length != 10) {
        return this.$swal.fire(
          "หมายเลขโทรศัพท์ ไม่ถูกต้อง กรุณากรอกใหม่",
          "",
          "error"
        );
      }
      await checkPhoneNumber(this.PhoneNumber, (res) => {
        if (res.status) {
          this.ReqStep = 2;
          this.setError(null);
        } else {
          return this.$swal.fire(res.message, "", "error");
        }
      });
    },
    async Step2checkBankNumber() {
      if (
        this.BankCode == "-1" ||
        (this.BankNumber.length != 10 && this.BankNumber.length != 12)
      ) {
        // return this.setError('กรุณากรอกข้อมูลก่อนยืนยัน')
        return this.$swal.fire("กรุณากรอกข้อมูลก่อนยืนยัน", "", "error");
      }

      await checkBankNumber(this.BankNumber, this.BankCode, (res) => {
        if (res.status) {
          if (res.data) {
            if (res.data.firstName != undefined) {
              this.FirstName = res.data.firstName;
            }
            if (res.data.lastName != undefined) {
              this.LastName = res.data.lastName;
            }
            if (res.data.token != undefined) {
              this.tokenBank = res.data.token;
            }
          }
          this.ReqStep = 3;
          this.setError(null);
        } else {
          return this.$swal.fire(res.message, "", "error");
        }
      });
    },
    async Login() {
      $("#regModal").modal("hide");
      $("#login").modal("show");
    },
  },
  async mounted() {
    if (this.shareToken != undefined) {
      localStorage.setItem("shareToken", this.shareToken);
    } else {
      if (this.shareToken == undefined) {
        if (localStorage.getItem("shareToken")) {
          this.shareToken = localStorage.getItem("shareToken");
        }
      }
    }
    $(".overlaymodal").on("click", function() {
      $("#regModal").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/RegisterForm.vue